export default __webpack_public_path__ + "static/media/Stamp1.63bd38c3.svg";